import { FontIcon } from 'react-md'
import styled from 'styled-components'

const Container = styled.div`
	display: flex;
	flex-flow: row wrap;
	align-items: center;
	font-size: 14px;
	margin-bottom: 8px;
`
const Item = styled.span`
	display: flex;
	align-items: center;
	color: #333;
`

type Props = {
	items: string[]
}

function Breadcrumbs({ items }: Props) {
	return (
		<Container>
			{items.map((item, index) => (
				<Item key={index}>
					{item}
					{index < items.length - 1 ? <FontIcon>arrow_right</FontIcon> : ''}
				</Item>
			))}
		</Container>
	)
}

export default Breadcrumbs
